import { C as CosmosIconClose$1, d as defineCustomElement$1 } from './p-CAeRxjul.js';

const CosmosIconClose = CosmosIconClose$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconClose, defineCustomElement };
